import { lazy, Suspense } from 'react'
import CurveWalletGate from '@/components/CurveWalletGate'
import type { SimPresale } from '@/lib/presale/types'

const PresaleSettleActions = lazy(() => import('@/components/PresaleSettleActions'))

function PresaleSettleBox({ presale }: { presale: SimPresale }) {
  return (
    <div className="mt-5 space-y-3 border-t border-white/10 pt-5">
      <h3 className="text-sm font-semibold text-white">Settle</h3>
      <CurveWalletGate actionLabel="Settle this presale">
        {() => (
          <Suspense fallback={<p className="text-xs text-zinc-500">Loading settle panel…</p>}>
            <PresaleSettleActions presale={presale} />
          </Suspense>
        )}
      </CurveWalletGate>
    </div>
  )
}

export default PresaleSettleBox
